(function(){
  // Build a map of variant ID → coming_soon metafield from the JSON element
  const comingSoonVariantsEl = document.getElementById('klaviyo-coming-soon-variants');
  const comingSoonVariants = comingSoonVariantsEl ? JSON.parse(comingSoonVariantsEl.textContent) : {};

  const isComingSoon = (variantId, available) => {
    return comingSoonVariants[String(variantId)] === true && available === false;
  };

  const showVariantMessage = (id) => {
    const variantMessage = document.querySelector(`.product__variant-message--${id}`);
    const variantMessages = document.querySelectorAll(`.product__variant-message`);
    if (typeof variantMessage !== 'undefined' && variantMessage !== null) {
      variantMessages.forEach(variantMessage => {
        variantMessage.style.display = 'none';
      });
      variantMessage.style.display = 'block';
    } else {
      variantMessages.forEach(variantMessage => {
        variantMessage.style.display = 'none';
      });
    }
  }

  const showComingSoonForm = (comingSoon, variantId) => {
    const bisWrapper = document.getElementById('klaviyo-bis-wrapper');
    const defaultBuyButtons = document.querySelector('.product-block--buy-buttons-custom, .product-block--buy-buttons');
    if (bisWrapper && variantId) {
      bisWrapper.dataset.variantId = variantId;
    }
    if (comingSoon) {
      if (bisWrapper) bisWrapper.style.display = 'block';
      if (defaultBuyButtons) defaultBuyButtons.style.display = 'none';
    } else {
      if (bisWrapper) bisWrapper.style.display = 'none';
      if (defaultBuyButtons) defaultBuyButtons.style.display = 'flex';
    }
  }

  document.addEventListener('variant:change', function(evt) {
    if (evt.detail.variant != null) {
      showVariantMessage(evt.detail.variant.id);
      showComingSoonForm(isComingSoon(evt.detail.variant.id, evt.detail.variant.available), String(evt.detail.variant.id));
    }
  });

  // Klaviyo Back in Stock form submission
  const bisWrapper = document.getElementById('klaviyo-bis-wrapper');
  if (bisWrapper) {
    const KLAVIYO_PUBLIC_KEY = bisWrapper.dataset.klaviyoKey;
    const KLAVIYO_LIST_ID = bisWrapper.dataset.klaviyoList;
    const form = document.getElementById('klaviyo-bis-form');
    const emailInput = document.getElementById('klaviyo-bis-email');
    const newsletter = document.getElementById('klaviyo-bis-newsletter');
    const submitBtn = document.getElementById('klaviyo-bis-submit');
    const btnText = submitBtn.querySelector('.klaviyo-bis-btn-text');
    const btnLoading = submitBtn.querySelector('.klaviyo-bis-btn-loading');
    const successMsg = document.getElementById('klaviyo-bis-success');
    const errorMsg = document.getElementById('klaviyo-bis-error');

    function setLoading(state) {
      submitBtn.disabled = state;
      btnText.style.display = state ? 'none' : 'inline';
      btnLoading.style.display = state ? 'inline' : 'none';
    }

    function hideMessages() {
      successMsg.style.display = 'none';
      errorMsg.style.display = 'none';
    }

    function showError() {
      errorMsg.style.display = 'block';
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = emailInput.value.trim();

      emailInput.classList.remove('is-invalid');
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        emailInput.classList.add('is-invalid');
        emailInput.focus();
        return;
      }

      const variantId = bisWrapper.dataset.variantId;
      setLoading(true);
      hideMessages();

      const bisPayload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
            }
          }
        }
      };

      const bisRequest = fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY,
        { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-06-15' }, body: JSON.stringify(bisPayload) }
      );

      const requests = [bisRequest];

      if (KLAVIYO_LIST_ID && KLAVIYO_LIST_ID !== 'YOUR_LIST_ID') {
        const listPayload = {
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email } } } },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
          }
        };
        requests.push(fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY,
          { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-06-15' }, body: JSON.stringify(listPayload) }
        ));
      }

      Promise.all(requests)
        .then(function(responses) {
          const bisOk = responses[0].status === 202 || responses[0].ok;
          if (bisOk) {
            form.style.display = 'none';
            successMsg.style.display = 'block';
          } else {
            showError();
          }
        })
        .catch(showError)
        .finally(function() { setLoading(false); });
    });
  }

})()
